export default "__VITE_ASSET__CHa4nWcb__"